import React from "react"
import * as styles from "./styles.module.scss"
import {useTranslation} from "gatsby-plugin-react-i18next"

export default function Footer() {
  const {t} = useTranslation();
  return (
    <footer className={styles.section}>
      <p>
        {t("FooterP1","このサイトは、DJ・配信イベント告知サイトテンプレート「Kitekure」の紹介ページです。")}
        <br/>
        {t("FooterP2","デモページにある内容は（一部実在のイベントをベースにしていますが）架空のものです。")}
        <br/>
        Code licensed under MIT License. <a href="https://github.com/sanographix/kitekure">GitHub Project</a>
      </p>
      <address>
        Made by <a href="http://www.sanographix.net/">SANOGRAPHIX</a>
        <br />
        <a href="http://twitter.com/sanographix">Twitter</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="http://facebook.com/sanographix.net">Facebook</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="https://www.instagram.com/sanographix/">Instagram</a>
      </address>
    </footer>
  )
}
